import { Link } from '@remix-run/react';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';

const ThemedNavGroupLink = ({ path, text }: { text: string | React.ReactNode; path: string }) => {
  const { webTheme } = useWebThemeContext();

  return (
    <Link to={path} className="sm:max-w-36 sm:text-wrap">
      <Typography
        as="p"
        size={'xs'}
        weight="regular"
        color={webTheme.footer_text_color}
        fontFamilyv2={webTheme.font_body}
      >
        {text}
      </Typography>
    </Link>
  );
};

export default ThemedNavGroupLink;
